import { ConfirmImportsRequest, FieldsAPI } from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEY } from './consts'

export const useConfirmImports = () => {
  const queryClient = useQueryClient()

  return useMutation((request: ConfirmImportsRequest) => FieldsAPI.confirmImports(request), {
    mutationKey: [QUERY_KEY.FIELD_CONFIRM_IMPORT],
    onSuccess: (a, request) => {
      queryClient.invalidateQueries([QUERY_KEY.COLLECTION])

      if (request.owner) {
        queryClient.invalidateQueries(['org_users', +request.owner])
      }
    },
  })
}
